import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const NumberField = ({
  name,
  placeholder,
  displayName,
  icon,
  value,
  min,
  max,
  error,
  touched,
  shrink,
  handleChange,
  classes,
  shrinkFieldOnly,
  required,
  disabled,
  returnString,
}) => {
  const { t } = useTranslation();
  const shrinkField = shrink || shrinkFieldOnly ? ' shrink-field' : '';
  const shrinkLabel = shrink ? ' shrink-label' : '';

  return (
    <div className={`custom-input-box${classes ? ' ' + classes : ''}`}>
      {displayName && (
        <label
          htmlFor={name}
          className={!touched && error ? 'label-error' + shrinkLabel : shrinkLabel}
        >
          {t(displayName)}
          {required && <span className='lh-1 theme-size-1_5 theme-text-red-1 px-1'>*</span>}
        </label>
      )}
      <div className='custom-input-field'>
        <input
          type='number'
          id={name}
          name={name}
          className={!touched && error ? 'input-error' + shrinkField : shrinkField}
          placeholder={t(placeholder)}
          disabled={disabled}
          value={value}
          autoComplete='off'
          onChange={(e) => {
            if (!returnString) {
              let val = Number(e.target.value);
              if (min !== undefined && val < min) val = min;
              if (max !== undefined && val > max) val = max;
              handleChange(e.target.name, val);
            } else handleChange(e.target.name, e.target.value);
          }}
        />
        {icon && <img src={icon} className='icon' />}
      </div>
      {!touched && error && <p className='form-field-error'>{t('error ' + error)}</p>}
    </div>
  );
};

NumberField.propTypes = {
  name: PropTypes.string.isRequired,
  displayName: PropTypes.string,
  placeholder: PropTypes.string,
  icon: PropTypes.string,
  value: PropTypes.number,
  min: PropTypes.number,
  max: PropTypes.number,
  error: PropTypes.string,
  touched: PropTypes.bool,
  shrink: PropTypes.bool,
  handleChange: PropTypes.func.isRequired,
  classes: PropTypes.string,
  shrinkFieldOnly: PropTypes.bool,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  returnString: PropTypes.bool,
};

export default NumberField;
